<ion-app>
  <scania-spinner></scania-spinner>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
